// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-0559d2a0] {\n  font-weight: bold;\n  color: #000;\n}", ""]);
// Exports
module.exports = exports;
